module.exports = __webpack_public_path__ + "static/media/shopify-setup.e016d55a.png";